import { render, staticRenderFns } from "../../../pages/physician/index/index.html?vue&type=template&id=532f3a32&scoped=true&"
import script from "../../../pages/physician/index/index.js?vue&type=script&lang=js&"
export * from "../../../pages/physician/index/index.js?vue&type=script&lang=js&"
import style0 from "../../../pages/physician/index/index.css?vue&type=style&index=0&id=532f3a32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f3a32",
  null
  
)

export default component.exports